import React, { useEffect, useState } from "react";
import ipeEnquiryService from "../../services/ipeEnquiryService";

export default function MachineGroupSelectorModal({
  show,
  onClose,
  onSelect,
  selected = [],
  primary = null
}) {

  const [machineGroups, setMachineGroups] = useState([]);
  const [checked, setChecked] = useState(selected || []);
  const [primaryId, setPrimaryId] = useState(primary || null);

  // ------------------------------------------------------------
  // Load Machine Groups
  // ------------------------------------------------------------
  useEffect(() => {

    if (!show) return;

    async function load() {
      try {
        const data = await ipeEnquiryService.getMachineGroups(); // YOU MUST HAVE / ADD
        setMachineGroups(data);
      } catch (e) {
        console.error("Failed to load machine groups", e);
      }
    }

    load();

  }, [show]);

  // ------------------------------------------------------------
  // Toggle Selection
  // ------------------------------------------------------------
  function toggle(id) {

    if (checked.includes(id)) {

      const updated = checked.filter(x => x !== id);
      setChecked(updated);

      if (primaryId === id) {
        setPrimaryId(null);
      }

    } else {

      const updated = [...checked, id];
      setChecked(updated);

      // Auto primary if first
      if (updated.length === 1) {
        setPrimaryId(id);
      }

    }

  }

  // ------------------------------------------------------------
  // Save Selection
  // ------------------------------------------------------------
  function handleSave() {

    if (checked.length === 0) {
      alert("Select at least one machine group");
      return;
    }

    onSelect({
      machineGroups: checked,
      primary: primaryId
    });

    onClose();

  }

  if (!show) return null;

  return (

    <div className="modal d-block" style={{ background: "rgba(0,0,0,0.5)" }}>

      <div className="modal-dialog modal-lg">
        <div className="modal-content">

          <div className="modal-header">
            <h5>Select Machine Groups</h5>
            <button className="btn-close" onClick={onClose}></button>
          </div>

          <div className="modal-body">

            {machineGroups.map((mg) => (

              <div key={mg.id} className="d-flex align-items-center mb-2">

                <input
                  type="checkbox"
                  className="form-check-input me-2"
                  checked={checked.includes(mg.id)}
                  onChange={() => toggle(mg.id)}
                />

                <span className="flex-grow-1">
                  {mg.group_name}
                </span>

                {checked.includes(mg.id) && (
                  <input
                    type="radio"
                    name="primaryMG"
                    checked={primaryId === mg.id}
                    onChange={() => setPrimaryId(mg.id)}
                  />
                )}

                {checked.includes(mg.id) && (
                  <span className="ms-1 text-muted">Primary</span>
                )}

              </div>

            ))}

          </div>

          <div className="modal-footer">

            <button className="btn btn-secondary" onClick={onClose}>
              Cancel
            </button>

            <button className="btn btn-primary" onClick={handleSave}>
              Add Selected
            </button>

          </div>

        </div>
      </div>

    </div>

  );

}